(function() { module.exports = window["wp"]["formatLibrary"]; }());